import { render } from "./AttendanceDetail.vue?vue&type=template&id=a8101ec2"
import script from "./AttendanceDetail.vue?vue&type=script&lang=js"
export * from "./AttendanceDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__